import { EArtType } from "@litres-libs/types";
import type { ILabelProps } from "./types";

export const getFormat = (props: ILabelProps) => {
  const { type: artType, isPreorder, linkType, isDraft, isTTS } = props;
  const isForListen = [
    EArtType.audio,
    EArtType.ozonAudio,
    EArtType.olesiejukAudio,
    EArtType.podcast,
    EArtType.podcastEpisode,
  ].includes(artType);
  const isForReading = !isForListen;
  const isSynced = linkType && linkType === "SYNCED";

  const type: "mini" | "midi" | "full" = props.size || "midi";

  let icon: "iconAudio" | "iconText" | undefined;
  switch (artType) {
    case EArtType.audio:
    case EArtType.ozonAudio:
    case EArtType.olesiejukAudio:
    case EArtType.podcast:
    case EArtType.podcastEpisode:
      icon = "iconAudio";
      break;
    case EArtType.text:
    case EArtType.pdf:
    case EArtType.epub:
      icon = "iconText";
      break;
  }

  let linkIcon: "iconAudio" | "iconText" | undefined;
  if (linkType && icon) {
    linkIcon = icon === "iconAudio" ? "iconText" : "iconAudio";
  }

  let status: string | undefined;
  if (isTTS) {
    status = "Авточтец";
  }
  if (isPreorder) {
    status = "Предзаказ";
  }
  if (artType === EArtType.pdf && !isDraft) {
    status = "PDF";
  }

  let label = "Текст";
  if (isDraft) {
    label = artType === EArtType.pdf ? "Черновик PDF" : "Черновик";
  } else {
    switch (artType) {
      case EArtType.podcast:
      case EArtType.podcastEpisode:
        label = "Подкаст";
        break;
      case EArtType.webtoon:
      case EArtType.webtoonChapter:
        label = "Вебтун";
        break;
      case EArtType.gardner:
      case EArtType.read:
      case EArtType.ozonText:
      case EArtType.olesiejukText:
        label = "Бумага";
        break;
      case EArtType.audio:
      case EArtType.ozonAudio:
      case EArtType.olesiejukAudio:
        label = "Аудио";
        break;
      case EArtType.gift:
        label = "Карта";
        break;
    }
  }

  return {
    type: type,
    format: {
      icon: icon,
      linkIcon: linkIcon,
      label: label,
      isSynced: isSynced,
      isForReading: isForReading,
      isForListen: isForListen,
      status: status,
    },
  };
};
